export default "__VITE_ASSET__UQAXOW$z__"